<template>
    <label class="form-label"><slot></slot></label>
</template>

<script>
export default {
    name: "FormLabel"
}
</script>

<style scoped>

</style>
